import { IListFetcher } from '../fetchers/IListFetcher';
import { Filter } from '../helpers/Filter';
import { ServerApiMapper } from '../helpers/ServerModelHelper';
import { Module } from '../Module';
import {
  GetDataConnectionTypesRequest,
  IGetDataConnectionTypesResult,
} from '../ServerApi/requests/GetDataConnectionTypesRequest';
import { GetFieldValuesRequest } from '../ServerApi/requests/GetFieldValuesRequest';
import { IDataConnectionType } from '../ServerApi/types/IDataConnection';
import { IFieldValue } from '../ServerApi/types/IFieldValue';
import { FieldValueResourceType } from '../ServerApi/types/IFieldValuesParams';
import { FilterFieldNames } from '../ServerApi/types/IFilterClause';
import { FetcherFactory } from '../services/FetcherFactory';
import { ServerService } from '../services/ServerService';
import { FieldValuesQuery } from './FieldValuesQuery';
import { Resource } from './Resource';

export class DataConnectionTypes extends Resource<IDataConnectionType> {

  public static $inject = ['ServerService', 'FetcherFactory'];

  private fieldValuesFetcher: IListFetcher<IFieldValue>;

  constructor(server: ServerService, FetcherFactory: FetcherFactory) {
    super(FetcherFactory.getServerResourceFetcher(
      GetDataConnectionTypesRequest,
      (result: IGetDataConnectionTypesResult) => result.dataConnectionTypes));

    this.fieldValuesFetcher = FetcherFactory.getServerResourceFetcher(GetFieldValuesRequest, ServerApiMapper.fieldValues);
  }

  public getByDataConnectionType(dataConnectionType: string): ng.IPromise<IDataConnectionType> {
    return this.all()
      .withFilters([Filter.stringFieldEq(FilterFieldNames.connectionType, dataConnectionType)])
      .getFirst();
  }

  public valuesForField(field: string): FieldValuesQuery {
    return new FieldValuesQuery(this.fieldValuesFetcher, field, 'dataConnection');
  }

}

Module.instance().service('DataConnectionTypes', DataConnectionTypes);
